export default "__VITE_ASSET__462b980e__"